import { render, staticRenderFns } from "./wo_list_page.vue?vue&type=template&id=2b6a6c40&scoped=true&"
import script from "./wo_list_page.vue?vue&type=script&lang=js&"
export * from "./wo_list_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a6c40",
  null
  
)

export default component.exports